import React, {useEffect, useState} from 'react';
import {Box, Divider, Grid, Typography} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '../../hooks/auth/UserProvider';
import { checkUserEnabled } from '../../helpers/authorizedUser';
import { GREEN_MAIN } from '../../theme/colors';
import MarketsGeo from './MarketsGeo';
import MarketsList from './MarketsList';
import { useWaiter } from '../../hooks/waiter/WaiterProvider';

const Network = () => {
    const navigate = useNavigate();
    const {isForbidden} = useUserContext();
    const {t} = useTranslation();
    // utente autorizzato
    const [isEnabled, setIsEnabled] = React.useState(false)
    const {user, auth, checkIsAuth} = useUserContext();
    const {setWaiterView} = useWaiter();

    useEffect(() => {
        if(isForbidden){
            setWaiterView(false);
            navigate('/');
        }
    }, [isForbidden]);
    
    // check is auth
    useEffect(() => {
        if (auth.isLoading) return;
    
        // Se l'utente non è autenticato → fai partire il login con redirect alla pagina corrente
        if (!auth.isAuthenticated) {
            auth.signinRedirect({ state: window.location.pathname });
            return;
        }
    
        // Se autenticato ma user non è abilitato → torna alla home
        if (auth.user && user && !checkUserEnabled(user)) {
            navigate('/');
            return;
        }
    
        // Se tutto ok → abilita la vista
        setIsEnabled(true);
    
        // Esegui comunque il controllo auth
        checkIsAuth().finally();
    
    }, [auth.isLoading, auth.isAuthenticated, auth.user, user, navigate]);
    // fine utente autorizzato

    return(
        !isForbidden ? <>
            <Box sx={{
                width:'100%', 
                display:'flex', 
                flexDirection:'column',
                color: GREEN_MAIN,
                fontFamily:'poppins'
            }}>
                {
                    auth.isAuthenticated && isEnabled &&
                    <>
                        {/* Main title */}
                        <Typography
                            variant="h3"
                            component="h1"
                            sx={{
                                fontWeight: "bold",
                                paddingBottom: 5
                            }}
                        >
                            {t("Il Circuito")}
                        </Typography>
                        
                        <MarketsGeo />

                        <Box sx={{paddingBottom: 3}}/>

                        <MarketsList />
                    </>
                }
            </Box>
        </>
        : <></>
    )
}

export default Network;